import { render, staticRenderFns } from "./modalEditService.vue?vue&type=template&id=a2b0c95c&scoped=true&"
import script from "./modalEditService.vue?vue&type=script&lang=js&"
export * from "./modalEditService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b0c95c",
  null
  
)

export default component.exports